import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.board.edit');
import { OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import moment from "moment";
import showdown from 'showdown';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-gsdcuser-board-edit',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.board.edit/view.scss */
/* src/app/portal.gsdcuser.board.edit/view.scss: no such file or directory */`],
})
export class PortalGsdcuserBoardEditComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() board_id: any;
    @Input() category: any;

    @ViewChild('editor')
    public editorElement: ElementRef;
    public comments: any = [];
    public comment_text: any = '';
    public commentFiles: any = [];

    public board: any = {};
    public editor: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
        await this.buildEditor();
        await this.service.loading.hide();
    }

    public async load() {
        if (this.board_id != 'new') {
            const { code, data } = await wiz.call("get", { id: this.board_id });
            if (code != 200) return await this.service.alert.error("Error!");

            this.board = data.item;
            this.board.extra = JSON.parse(this.board.extra.replace(/'/g, '"'));
            this.comments = data.comments;
        } else {
            this.board = {
                title: '',
                content: '',
                extra: [],
                created: moment().format("YYYY-MM-DD")
            };
        }

        await this.service.render();
    }

    public async buildEditor() {
        let editor = this.editor = await ClassicEditor.create(document.querySelector("textarea#editor"), {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.data.set(this.board.content);

        await this.service.render();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async update() {
        if (this.board.title == "") return await this.service.alert.error("제목을 입력해주세요.");
        if (this.tab == 'text') this.changeTab('editor')
        this.board.content = this.editor.data.get();
        let data: any = JSON.stringify(this.board);
        const { code } = await wiz.call("update", { data: data });
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success('저장되었습니다');

        if (!this.board.id) {
            this.router.navigateByUrl('/board');
        }
    }

    public tab = "editor";
    public changeTab(tab) {
        if (tab === "editor") {
            this.editor.data.set(this.board.content);
        }
        this.tab = tab;
        this.service.render();
    }

    public async delete() {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("delete", { id: this.board.id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.router.navigateByUrl('/board');
    }

    public fd = new FormData();
    public uploading: boolean = false;
    public async fileUpload(e) {
        if (!this.board.extra) this.board.extra = [];
        // await this.service.loading.show();
        this.uploading = true;
        await this.service.render();
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            this.filename = file.name;
            if (!file.filepath) file.filepath = file.name;
            this.fd.append('upload', file);
            let fdurl = '/file/upload';
            const { url } = await this.service.file.upload(fdurl, this.fd, async (percent: number, total: number, position: number) => { });
            let fileInfo = { name: file.name, size: file.size, url: url }
            this.board.extra.push(fileInfo);
        }
        // await this.service.loading.hide();
        this.uploading = false;
        await this.service.render();
    }

    public async removeAttachment(index: number) {
        this.board.extra = this.board.extra.filter((_, i) => i !== index);
        await this.service.render();
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }

}

export default PortalGsdcuserBoardEditComponent;